import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0 font-heading">
        404
      </h1>
      <div className="relative z-10">
        <span className="w-16 h-16 mx-auto rounded-full bg-background-200 flex items-center justify-center">
          <i className="ri-compass-3-line text-3xl text-foreground-500" />
        </span>
        <h1 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mt-5">页面走丢了</h1>
        <p className="mt-2 text-sm text-foreground-600 font-mono">{location.pathname}</p>
        <p className="mt-2 text-sm text-foreground-600">您访问的页面不存在或已被移除</p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
          <Link
            to="/category"
            className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-background-100 border border-background-300 hover:border-primary-400 text-foreground-950 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-compass-3-line" />
            浏览分类
          </Link>
        </div>
      </div>
    </div>
  );
}